import React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { General } from '../../../../pages/settings/General';

export const Route = createFileRoute('/_private/_home/settings/general')({
  component: GeneralRoute,
});

function GeneralRoute() {
  const { apiClient } = Route.useRouteContext();
  return <General portalApiClient={apiClient} />;
}
